'use client'
import { useTranslation } from 'next-i18next'
import React from 'react'

import { STATSIG_EXPERIMENTS, STATSIG_EXPERIMENTS_BUCKETS } from '@src/config/statsig-experiments.config'
import { useStatsigExperiment } from '@src/experiments/statsig-integration'
import { useGladlyChat } from '@src/hooks/useGladlyChat'
import { Button, BUTTON_TYPES } from '@src/quince-components/src'
import {
  getAddClickOnHyperRenderOption,
  TRACKING_EVENT_BY_SECTION_TYPES,
} from '@src/quince-site-integrated/src/components/ContactUs/MarketingSection'
import { ChatProvider } from '@src/quince-site-integrated/src/integrations/chat-integration/chat-provider.types'
import richTextRenderer from '@src/quince-site-integrated/src/utils/richTextRenderer'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'

import { TextSection, Banner } from '../../contact-us.types'

import styles from './support.module.scss'

interface Props {
  sections: TextSection[]
  title?: TextSection
  bannerData?: Banner
  disclaimerText?: TextSection
}

const SupportSection = ({ sections = [], disclaimerText }: Props) => {
  const { openChat } = useGladlyChat()
  const { t } = useTranslation('common')
  const { experimentBucket, init } = useStatsigExperiment(STATSIG_EXPERIMENTS.CHAT_PROVIDER_DEFAULT)

  const isDecagon = init && experimentBucket === STATSIG_EXPERIMENTS_BUCKETS.SHOW

  const handleOpenChat = () => {
    if (!isDecagon) {
      openChat()
    } else if (window.duet) {
      trackEvent(TELEMETRY_EVENT_NAMES.SUPPORT_CHAT_INITIATED, {
        provider: ChatProvider.DECAGON,
      })
      window.duet.open()
    }
  }

  return (
    <div className={styles.supportWrapper}>
      <div className={styles.supportHeader}>{t('still_need_help')}</div>
      <div className={styles.support}>
        {sections.map((textObj, idx) => (
          <div className={styles.card} key={`support_${idx}`}>
            {richTextRenderer(
              textObj.text.json,
              TRACKING_EVENT_BY_SECTION_TYPES[textObj.sectionType]
                ? getAddClickOnHyperRenderOption(() => {
                    trackEvent(TRACKING_EVENT_BY_SECTION_TYPES[textObj.sectionType], {
                      placing: 'contact_us',
                    })
                  })
                : undefined,
            )}
            {idx === 0 && (
              <Button classNames={[styles.card__link]} type={BUTTON_TYPES.SECONDARY_LINK} onClick={handleOpenChat}>
                {t('chat_now')}
              </Button>
            )}
          </div>
        ))}
      </div>
      <div className={styles.supportDisclaimer}> {richTextRenderer(disclaimerText?.text.json)}</div>
    </div>
  )
}

export default SupportSection
